/*eslint eqeqeq: "off"*/
import {
  ADD_NEW_STOCK__DETAILS,
  UPDATE_PRODUCT_STOCK_DETAILS,
  FIND_PRODUCT_BY_NAME_DESIGN,
  FETCH_ALL_PRODUCT_STOCK_ENTRY_LIST,
  EDIT_OLD_SINGLE_PRODUCT_STOCK_DETAILS,
  DELETE_PRODUCT_STOCK_ENTRY_DETAILS,
} from "./_product_Stock_Type";
const initialState = {
  _editedDetails: "",
  _msg: "",
  _allDetails: [],
};

const productStockReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NEW_STOCK__DETAILS:
      return {
        ...state,
        _allDetails: [action.payload, ...state._allDetails],
      };
    case EDIT_OLD_SINGLE_PRODUCT_STOCK_DETAILS:
      return {
        ...state,
        _editedDetails: action.payload,
      };
    case UPDATE_PRODUCT_STOCK_DETAILS:
      return {
        ...state,
        _editedDetails: "",
        _allDetails: state._allDetails.map((obj) =>
          obj.id == action.payload.id ? action.payload : obj
        ),
      };
    case FETCH_ALL_PRODUCT_STOCK_ENTRY_LIST:
      return {
        ...state,
        _editedDetails: "",
        _allDetails: action.listview,
        _msg: "",
      };
    case FIND_PRODUCT_BY_NAME_DESIGN:
      return {
        ...state,
        _editedDetails: action.data,
        _msg: "",
      };
    case DELETE_PRODUCT_STOCK_ENTRY_DETAILS:
      return {
        ...state,
        _edituserDetails: "",
        _allDetails: state._allDetails.filter(
          (record) => record.id != action.payload
        ),
      };

    default:
      return state;
  }
};

export default productStockReducer;
